import {Component, Input, OnInit, QueryList, ViewChildren} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

import {LoadingIndicatorService} from '@services/loading-indicator/loading-indicator.service';
import {MachineService} from '@services/administration/machine/machine.service';
import {NotificationService} from '@services/notification/notification.service';
import {TableHeaderSortableService} from '@services/table-header-sortable/table-header-sortable.service';
import {GatewayStatusService} from '@services/gateway-status/gateway-status.service';

import {SortEvent, TableHeaderSortableDirective} from '@shared/table-header-sortable/table-header-sortable.directive';
import {ModalDialogDismissOption} from '@shared/confirmation-dialog/modal-dialog-dismiss-option';

import {Gateway} from '@models/gateway/gateway';
import {GATEWAY_STATUS} from '@constants/gateway/gateway-status';


@Component({
    selector: 'scitis-admin-gateway',
    templateUrl: './gateway.component.html',
    styleUrls: ['./gateway.component.scss'],
    standalone: false
})
export class GatewayComponent implements OnInit {

  @Input()
  machineId: number = -1;

  @Input()
  tenantId: number = -1;

  gatewaysList: Gateway[] = new Array<Gateway>();
  searchTerm: string = '';

  private CURRENT_PAGE_NAME = 'Gateway';

  @ViewChildren(TableHeaderSortableDirective) sortableHeaders: QueryList<TableHeaderSortableDirective> = new QueryList<TableHeaderSortableDirective>();

  constructor(
      private loadingIndicator: LoadingIndicatorService,
      private translation: TranslateService,
      private machineService: MachineService,
      private notificationService: NotificationService,
      private tableHeaderSortableService: TableHeaderSortableService,
      private gatewayStatusService: GatewayStatusService,
      private activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
    this.setGateways();
  }

  onColumnSort({column, direction}: SortEvent): void {
    this.sortableHeaders = this.tableHeaderSortableService.resetHeaders(this.sortableHeaders, column);
    this.gatewaysList = this.tableHeaderSortableService.sortItems<Gateway>(this.gatewaysList, column, direction);
  }

  onClose(): void {
    this.activeModal.dismiss(ModalDialogDismissOption.CLOSE);
  }

  getStatusClass(computedStatus: GATEWAY_STATUS): string {
    switch (computedStatus) {
      case GATEWAY_STATUS.ONLINE:
        return 'status-success';
      case GATEWAY_STATUS.PARTIALLY_DISCONNECTED:
        return 'status-warning';
      case GATEWAY_STATUS.OFFLINE_OR_UNKNOWN:
        return 'status-danger';
      case GATEWAY_STATUS.MISSING:
        return 'status-danger';
      default:
        return '';
    }
  }

  private setGateways(): void {
    this.loadingIndicator.show(this.translation.instant('Loading'));
    this.machineService.listGateways(this.machineId).subscribe({
      next: (gateways: Gateway[]) => {
        this.gatewaysList = this.determineGatewaysStatuses(gateways);
        this.loadingIndicator.hide();
      }, error: error => {
        console.log(error);
        const message = this.translation.instant('Error getting gateways list.');
        this.loadingIndicator.hide();
        this.notificationService.error(message, error, this.CURRENT_PAGE_NAME, true);
      }
    });
  }

  private determineGatewaysStatuses(gateways: Gateway[]): Gateway[] {
    if (gateways && gateways.length > 0) {
      for (const gateway of gateways) {
        gateway.computedStatus = this.gatewayStatusService.determineGatewayStatusByType(gateway);
      }
    }
    return gateways;
  }

}
